export const from = 6;
export const to = 7;

export function up(schema) {
  const { styles, ...newSchema } = schema;
  const { font, ...newStyles } = styles;

  return {
    ...newSchema,
    styles: {
      ...newStyles,
      fonts: {
        header: {
          dropShadow: 'none',
          fontSize: 32,
          ...font,
        },
        body: {
          dropShadow: 'none',
          fontSize: 24,
          ...font,
        },
      },
      colors: [newStyles?.primaryTextColor, newStyles?.secondaryTextColor],
    },
    version: to,
  };
}

export function down(schema) {
  const { styles, ...newSchema } = schema;
  const { fonts, colors, ...newStyles } = styles;
  const { dropShadow, fontSize, ...header } = fonts.header;

  return {
    ...newSchema,
    styles: {
      ...newStyles,
      font: header,
    },
    version: from,
  };
}

export default {
  from,
  to,
  up,
  down,
};
